import axios from 'axios';

export const apiService = {
    get,
    post,
    put,
    delete: deleteReq,
    postMultiData
};

function get(url, inBG) {
    return doRequest(
        url,
        {
            method: 'GET'
        },
        inBG
    );
}

function post(url, data, inBG) {
    return doRequest(
        url,
        {
            method: 'POST',
            body: data
        },
        inBG
    );
}

function put(url, data, inBG) {
    return doRequest(
        url,
        {
            method: 'PUT',
            body: data
        },
        inBG
    );
}

function deleteReq(url, data, inBG) {
    return doRequest(
        url,
        {
            method: 'DELETE',
            body: data
        },
        inBG
    );
}

function postMultiData(url, data, onUploadProgress) {
    const formData = new FormData();
    Object.keys(data).forEach(name => {
        formData.append(name, data[name]);
    });
    const requestOptions = {
        headers: {
            'content-type': 'multipart/form-data'
        },
        onUploadProgress
    };
    return axios
        .post(url, formData, requestOptions)
        .then(response => response.data)
        .catch(e => {
            if (!e.reason) {
                e.reason = 'net';
                e.errors = { globalError: e.message };
            }
            throw e;
        });
}

function doRequest(url, opts, inBG) {
    const requestOptions = { ...opts };
    if (requestOptions.method === 'POST' || requestOptions.method === 'PUT' || requestOptions.method === 'DELETE')
        requestOptions.headers = {
            ...requestOptions.headers,
            'Content-Type': 'application/json'
        };

    return fetch(url, requestOptions)
        .then(response => handleResponse(response, inBG))
        .catch(e => {
            if (!e.reason) {
                e.reason = 'net';
                e.errors = { globalError: e.message };
            }
            throw e;
        });
}

function handleResponse(response, inBG) {
    return response.text().then(text => {
        let data;
        try {
            data = text && JSON.parse(text);
        } catch (e) {
            data = text;
        }
        console.log('response', data);
        if (!response.ok) {
            /*if (response.status === 401) {
                // auto logout if 401 response returned from api
                localStorage.removeItem('user');
                window.location.reload();
                return;
            }*/

            if (typeof data !== 'object') data = { message: data };
            data.message = data.message || response.statusText;
            data.reason = 'server';
            data.status = response.status;
            throw data;
        }

        return data;
    });
}
